/**
 * Production module values shared between the Worker and the SPA.
 *
 * Dependency-free on purpose — the tsconfig.app.json contract glob bundles
 * this file into the SPA (see the comment there), so it must not import
 * anything from the Worker runtime.
 */

/**
 * Process (proses) code → display name for all eight fixed Korgun processes.
 *
 * `Proses_M.Tanim` was typed on a terminal that could not produce the full
 * Turkish alphabet, so 05–08 are stored without their diacritics (`USTE`,
 * `TEMIZLEME`, `SARAC`); the values here are the corrected spellings. The
 * codes are fixed in Korgun — an unknown code has no entry and stays a raw
 * code wherever this table is the only source.
 *
 * The SPA needs this where no `Proses_M` row is at hand (the emir list's
 * proses-filter pill); the Worker's `lib/proses.ts` builds its diacritic
 * corrections from it.
 */
export const PROSES_NAMES: Record<string, string> = {
  '01': 'KESİM',
  '02': 'SAYA',
  '03': 'SAYA KONTROL',
  '04': 'MONTE',
  '05': 'ÜSTE',
  '06': 'TEMİZLEME',
  '07': 'SARAÇ',
  '08': 'ASTAR KESİM',
}
